import Phaser from "phaser";
import type { Move } from "../types";
import type BattlePair from "../entities/BattlePair";

export interface AttackOutcome {
  hit: boolean;
  damage: number;
}

/**
 * Хит-чек учитывает эвазию защищающегося. evadeBuff копится одноразово
 * (потом сбрасывается), поэтому здесь его consume.
 */
export function rollHit(move: Move, defender: BattlePair): boolean {
  const evade = defender.consumeEvade();
  const acc = move.accuracy * (1 - evade);
  return Math.random() < acc;
}

/**
 * Урон роллится равномерно из [damageMin..damageMax] (включительно).
 * Для support-ходов возвращает 0.
 */
export function rollDamage(move: Move): number {
  if (move.kind !== "attack") return 0;
  const min = move.damageMin ?? 1;
  const max = move.damageMax ?? min;
  return Phaser.Math.Between(min, max);
}
